export default __webpack_public_path__ + "static/media/icon_recommend-product.9d849e74.png";